import SuperadminCompanyRoutes from './route-types'

const CompanyListView = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../company/CompanyListView.vue')
const CompanyView = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../company/CompanyView.vue')
const CompanyDetail = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../companysetting/CompanyDetailSetting.vue')
const CompanyLicense = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../companysetting/CompanyLicenseSetting.vue')
const CompanyModules = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../companysetting/CompanyModulesSetting.vue')
const CompanyItemCategory = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../companysetting/CompanyItemCategorySetting.vue')
const CompanyExternal = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../companysetting/CompanyIntegrationSetting.vue')
const CompanyNewUser = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../companysetting/CompanyNewUserSetting.vue')
const UserListView = () => import(/* webpackChunkName: "company-onboarding-chunk" */ '../../user/UserListView.vue')

export default [
  {
    path: SuperadminCompanyRoutes.CompanyListView.path,
    name: SuperadminCompanyRoutes.CompanyListView.name,
    component: CompanyListView,
    meta: {
      title: 'Company List',
      name: 'Company List',
      fkey: 'supercompanylisting|filter',
      access: {
        isAdd: true
      }
    }
  },
  {
    path: SuperadminCompanyRoutes.CompanyDetail.path,
    name: SuperadminCompanyRoutes.CompanyDetail.name,
    component: CompanyView,
    meta: {
      title: 'Company',
      name: 'Company'
    },
    children: [
      {
        path: SuperadminCompanyRoutes.CompanyDetail.path,
        name: SuperadminCompanyRoutes.CompanyDetail.name,
        component: CompanyDetail,
        meta: {
          title: 'Detail',
          name: 'Detail',
          access: {
            isEdit: true,
            isDelete: true
          }
        }
      },
      {
        path: SuperadminCompanyRoutes.CompanyLicense.path,
        name: SuperadminCompanyRoutes.CompanyLicense.name,
        component: CompanyLicense,
        meta: {
          title: 'License',
          name: 'License',
          access: {
            isEdit: true,
            isDelete: true
          }
        }
      },
      {
        path: SuperadminCompanyRoutes.CompanyModules.path,
        name: SuperadminCompanyRoutes.CompanyModules.name,
        component: CompanyModules,
        meta: {
          title: 'Modules',
          name: 'Modules',
          access: {
            isEdit: true,
            isDelete: true
          }
        }
      },
      {
        path: SuperadminCompanyRoutes.CompanyItemCategory.path,
        name: SuperadminCompanyRoutes.CompanyItemCategory.name,
        component: CompanyItemCategory,
        meta: {
          title: 'Item Category',
          name: 'Item Category',
          access: {
            isEdit: true,
            isDelete: true
          }
        }
      },
      {
        path: SuperadminCompanyRoutes.CompanyExternal.path,
        name: SuperadminCompanyRoutes.CompanyExternal.name,
        component: CompanyExternal,
        meta: {
          title: 'External Setting',
          name: 'External Setting',
          access: {
            isEdit: true,
            isDelete: true
          }
        }
      },
      {
        path: SuperadminCompanyRoutes.CompanyNewUser.path,
        name: SuperadminCompanyRoutes.CompanyNewUser.name,
        component: CompanyNewUser,
        meta: {
          title: 'Default Administrator',
          name: 'Default Administrator',
          access: {
            isEdit: true
          }
        }
      }
    ]
  },
  {
    path: SuperadminCompanyRoutes.CompanyUserListView.path,
    name: SuperadminCompanyRoutes.CompanyUserListView.name,
    component: UserListView,
    meta: {
      title: 'Company Users',
      name: 'Company Users',
      fkey: 'companyuserlisting|filter'
    }
  }
]
